module.exports = __webpack_public_path__ + "img/scrm-1.858f8c82.png";